const user = {
    state: {
        userInfo: {},
        isJudges:false,//是否评委
        admin:-1,//0-区级管理员，1-校级管理员，-1-非管理员
    },
    //set方法
    mutations: {
        // setIsJudges
        SET_USERINFO(state,payload){
          state.userInfo = payload;
        },
        CLEAR_USERINFO(state){
          state.userInfo = {};
        }
    },
    actions: {
        // login({ commit, state }) {
        //     return new Promise((resolve, reject) => {
        //         resolve()
        //     })
        // }
    }
};

export default user;
